import React, { useContext } from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import { UserContext } from '../context/UserProvider.jsx'
import LoginPage from './LoginPage'
import NotFound from './NotFound'
import Dashboard from './Dashboard'
import Information from './Dashboard/information'
import PickupForm from './Dashboard/pickupForm'
import DeliveryBoxForm from './Dashboard/deliveryBoxForm'
import DeliveryForm from './Dashboard/deliveryForm'
import ReceivingLogin from './Receiving/Login'
import ReceivingHome from './Receiving/Home'
import ReceivingPackage from './Receiving/Package'

const ReceivingGuard = ({ children }) => localStorage.getItem('receivingToken') ? children : <ReceivingLogin />

function Controller() {
  const { token } = useContext(UserContext)

  return (
    <Router>
      <Routes>
        <Route path="/receiving/login" element={<ReceivingLogin />} />
        <Route path="/receiving" element={<ReceivingGuard><ReceivingHome /></ReceivingGuard>} />
        <Route path="/receiving/package/:code" element={<ReceivingGuard><ReceivingPackage /></ReceivingGuard>} />
        <Route path="/" element={token ? <Dashboard /> : <LoginPage />} />
        <Route path="/manifest" element={token ? <Dashboard /> : <LoginPage />} />
        <Route path="/manifest/:id" element={token ? <Information /> : <LoginPage />} />
        <Route path="/manifest/:date/pickup/:id" element={token ? <PickupForm /> : <LoginPage />} />
        <Route path="/manifest/:date/delivery-box/:id" element={token ? <DeliveryBoxForm /> : <LoginPage />} />
        <Route path="/manifest/:date/delivery/:id" element={token ? <DeliveryForm /> : <LoginPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  )
}

export default Controller
